import { render, staticRenderFns } from "./AxListItemStatic.vue?vue&type=template&id=6f9137b8&scoped=true&"
import script from "./AxListItemStatic.vue?vue&type=script&lang=ts&"
export * from "./AxListItemStatic.vue?vue&type=script&lang=ts&"
import style0 from "./AxListItemStatic.vue?vue&type=style&index=0&id=6f9137b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9137b8",
  null
  
)

export default component.exports